module.exports = __webpack_public_path__ + "static/media/site-preview.bc1207f1.png";